<template>
  <PageWrap page-title="Tipos de Inmuebles">
    <b-row>
      <b-col md="8" lg="6">
        <BfInput
          v-model="searchTerm"
          label="Búsqueda"
          data-key="key"
          placeholder="Buscar por nombre"
          @update="updateSearch"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="properties"
      :columns="tableColumns"
      border
      @row-click="tableRowClick"
            cell-class-name="tasaciones-small-cell"

    >
      <span slot="clave" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.clave}}
      </span>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'property'}" tag="router-link">Nuevo tipo de inmueble</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="properties.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { propertyTypeAPI } from '@/api';

export default {
  name: 'PropertyTypesList',

  data() {
    return {
      properties: [],
      currentPage: 1,
      loadingData: false,
      perPage: 15,
      totalRows: 0,
      searchTerm: null,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total },
        } = await propertyTypeAPI.getAll({
          search: this.searchTerm,
          page: this.currentPage,
          perPage: this.perPage,
        });

        this.properties = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },

    tableRowClick({ row, column }) {
      if (column.property === 'clave') {
        const { id } = row;
        router.push({ name: 'property', params: { id: `${id}` } });
      }
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;

        this.loadData();
      }
    },

    updateSearch() {
      this.loadData();
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Clave',
          dataKey: 'clave',
          width: 150,
        },
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
